import React, { HTMLAttributes } from "react";
import styles from "./LinkButton.module.css";

interface CustomIconButtonProps extends Omit<HTMLAttributes<HTMLDivElement>, "onClick"> {
	onClick: () => void;
}

export default function LinkButton({ onClick, className = "", children }: CustomIconButtonProps) {
	const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
		if (event.key === "Enter" && onClick) {
			onClick();
		}
	};
	return (
		<div
			className={`${styles.LinkButton} ${className}`}
			role="button"
			tabIndex={0}
			onClick={onClick}
			onKeyPress={handleKeyPress}
		>
			{children}
		</div>
	);
}
